// A phone number as a customer reads it: 920.716.6107.
//
// 10 digits, or 11 starting with the US country code 1, become XXX.XXX.XXXX
// whatever punctuation they were stored with. Anything else (an extension, an
// international number, a partial entry) is returned exactly as entered, so
// nothing is ever shown truncated or reshaped into a wrong number. Display
// only: stored values are never changed. Mirrored in
// server/services/formatPhone.js for the texts and emails the server writes.
export const formatPhone = (value) => {
  if (value === null || value === undefined) return '';
  const raw = String(value);
  let digits = raw.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  if (digits.length !== 10) return raw;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
};

export default formatPhone;
